export const buildQueryFilters = (filters: any): string => {
	const filterParams = Object.entries(filters)
		.map(([key, value]) => {
			if (Array.isArray(value)) {
				return value.map((v, index) => `${key}[${index}]=${encodeURIComponent(v)}`).join('&')
			} else if (typeof value === 'object' && value !== null) {
				// Handle object values by serializing them
				return Object.entries(value)
					.map(([subKey, subValue]) => `${key}[${subKey}]=${encodeURIComponent(String(subValue))}`)
					.join('&')
			}

			return `${key}=${encodeURIComponent(String(value))}`
		})
		.join('&')

	return filterParams
}